import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function OutsourcingListMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.drc.labContact.create(0));
  };

  return (
    <MainMenuItem
      itemTitleString="頭皮ラボへ連絡"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default OutsourcingListMenuItem;
